export const normalizeArea = (area: number, unit: string = 'metric') => {
  if (unit === 'metric') {
    return area * 0.0001;
  } else {
    return area * 0.000247105;
  }
};

export const getLngLat = (text: string): [number, number] | null => {
  const splitted = text.split(',');
  if (splitted.length === 2) {
    const lng = Number.parseFloat(splitted[0]);
    const lat = Number.parseFloat(splitted[1]);
    if (Number.isFinite(lat) && Number.isFinite(lng)) {
      return [lng, lat];
    } else {
      return null;
    }
  } else {
    return null;
  }
};

export const sortAlphabetically = (a: { name: string }, b: { name: string }) => {
  const nameA = a.name.toLocaleLowerCase();
  const nameB = b.name.toLocaleLowerCase();

  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }
  return 0;
};

export function capitalizeString(s: string) {
  return s.charAt(0).toUpperCase() + s.slice(1);
}
